import { wrapReducer } from "@client/content/lib/helper";
import { type FailureActionData } from "@client/lib/actions";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type GetAggregateSuccessActionData } from "./actions";
import { type Kpi } from "./types";

const reducer = (state: Kpi.State = defaultState, action: ReduxAction<any>): Kpi.State => {
  switch (action.type) {
    case Actions.GetAggregateBegin: {
      return {
        ...state,
        error: null,
        status: Status.Loading
      };
    }
    case Actions.GetAggregateFailure: {
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        error,
        status: Status.Ready
      };
    }
    case Actions.GetAggregateSuccess: {
      const data = action.data as GetAggregateSuccessActionData;
      return {
        ...state,
        status: Status.Ready,
        aggregateValue: data
      };
    }
    default:
      return state;
  }
};
export const defaultState: Kpi.State = {
  aggregateValue: null,
  error: null,
  id: "",

  status: Status.Ready
};
export const previewState: Kpi.State = {
  aggregateValue: {
    aggregate: 10,
    currencyCode: "USD",
    firstName: "Dummy",
    lastName: "Dummy",
    profilePictureUrl: null
  },
  error: null,
  id: "",

  status: Status.Ready
};
export default wrapReducer({ defaultState, reducer, previewState });
